const CookiesScreen = () => {

    return(
        <p>Cookies Screen</p>
    )

}

export default CookiesScreen